var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.reports },
    [
      _c("reports-title", { attrs: { title: _vm.pageTitle } }),
      _vm._v(" "),
      _c("reports-toolbar", {
        attrs: {
          "toolbar-disabled": _vm.isDisabledExport,
          "report-title": _vm.pageTitle,
        },
      }),
      _vm._v(" "),
      _vm.isShowSkeleton
        ? _c("skeleton-wrapper", {
            attrs: { id: "skeletonWrapper" },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          class: [
                            _vm.$style.chart_wrapper,
                            _vm.$style.chart_wrapper_pie,
                          ],
                        },
                        [
                          _c("doughnut-chart", {
                            class: "report_export_id",
                            attrs: {
                              "data-chart-type": "pie",
                              items: [],
                              static: true,
                              "tooltip-title": _vm.locale(
                                "chart_projects_by_statuses_tooltip_title"
                              ),
                              "stub-description": "",
                              config: _vm.chartViewConfig,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              4126437952
            ),
          })
        : _c(
            "div",
            { class: [_vm.$style.chart_wrapper, _vm.$style.chart_wrapper_pie] },
            [
              _c("doughnut-chart", {
                class: "report_export_id",
                attrs: {
                  "data-chart-type": "pie",
                  items: _vm.items,
                  static: _vm.isStub,
                  "tooltip-title": _vm.locale(
                    "chart_projects_by_statuses_tooltip_title"
                  ),
                  "stub-description": _vm.locale(
                    "report_page_no_filtered_data"
                  ),
                  config: _vm.chartViewConfig,
                  "with-delay": false,
                },
                on: { onCheckSelected: _vm.toggleLegend },
              }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }